import React, {FC, useEffect, useState} from "react"

import {ClassicCard} from "@irati/braze/services/sdk"
import braze from "@irati/braze/services/braze"
import authentication from "@irati/auth"
import HeaderLink from "../shared/HeaderLink"
import {NOTIFICATION_CENTER_CONTEXT} from "./const"
import NotificationBell from "../shared/Notifications/NotificationBell"

interface Props {
  id: any,
  user: any,
  togglePanel: (key?: string) => void
}

const MobileNotificationMenu: FC<Props> = ({user, togglePanel}) => {
  const [isMenuDisplayed, setIsMenuDisplayed] = useState<boolean>(false)
  const [contentCards, setContentCards] = useState<ClassicCard[]>([])

  useEffect(() => {
    if (authentication.isUserGhost()) return

    const result = braze.getContentCards()
    setContentCards(result)
  }, [])

  const handleClick = () => {
    setIsMenuDisplayed((current) => !current)
    togglePanel(NOTIFICATION_CENTER_CONTEXT)
    braze.markCardsAsSeen(contentCards)
  }

  if (!user || authentication.isUserGhost()) return null

  return (
    <HeaderLink data-attach-tooltip="Notification Center" onClick={handleClick}>
      <NotificationBell isDisplayed={isMenuDisplayed} count={contentCards.filter((card) => !card.viewed).length} />
    </HeaderLink>
  )

}

export default MobileNotificationMenu
